import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo } from 'react';
export const SectionContext = /*#__PURE__*/ createContext();
function withSectionContext(WrappedComponent) {
    const WithSectionContext = (props)=>{
        const contextValue = useMemo(()=>({
                section: props.section
            }), [
            props.section
        ]);
        return /*#__PURE__*/ React.createElement(SectionContext.Provider, {
            value: contextValue
        }, /*#__PURE__*/ React.createElement(WrappedComponent, props));
    };
    WithSectionContext.propTypes = {
        section: PropTypes.string
    };
    return WithSectionContext;
}
export const useSectionContext = ()=>useContext(SectionContext);
export default withSectionContext;
